import LandingReveal from '@/modules/Pages/shared/LandingReveal';

const outcomes = [
  {
    title: 'Fewer surprises',
    detail: "Spot meaningful risk before a customer's decision to leave becomes obvious.",
  },
  {
    title: 'Less wasted CS time',
    detail: "Spend less time investigating accounts that don't need action.",
  },
  {
    title: 'More control as you grow',
    detail: 'Know where your team should focus without trying to manually watch every customer.',
  },
];

export default function TransformationSection() {
  return (
    <section className="py-24 px-6 border-t border-light">
      <div className="max-w-6xl mx-auto">
        <LandingReveal className="max-w-3xl mb-6">
          <h2 className="landing-headline text-3xl md:text-4xl font-bold leading-tight mb-6">
            From reacting to churn to protecting more revenue
          </h2>
          <p className="landing-prose mb-12">
            When your team knows which customers actually need attention, you can get more from the CS capacity you
            already have.
          </p>
        </LandingReveal>

        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {outcomes.map((item, index) => (
            <LandingReveal
              key={item.title}
              delayClass={index === 0 ? 'landing-delay-1' : index === 1 ? 'landing-delay-2' : 'landing-delay-3'}
            >
              <div className="landing-card p-6 h-full">
                <p className="text-accent text-sm font-semibold uppercase tracking-wider mb-3">{item.title}</p>
                <p className="text-secondary text-lg leading-relaxed">{item.detail}</p>
              </div>
            </LandingReveal>
          ))}
        </div>

        <LandingReveal>
          <p className="text-center text-xl md:text-2xl font-semibold text-primary font-secondary leading-relaxed max-w-3xl mx-auto">
            Stay ahead of the customers at risk without asking your team to watch everyone.
          </p>
        </LandingReveal>
      </div>
    </section>
  );
}
